module.exports = __webpack_public_path__ + "static/media/news_banner.565bfa57.jpg";